module.exports = __webpack_public_path__ + "img/Penny-Tote-01.0a8447f8.jpg";